import api from './api';

const procurementService = {
  // Suppliers
  getSuppliers: (includeInactive = false) => api.get(`/suppliers?includeInactive=${includeInactive}`),
  getSupplier: (id: number) => api.get(`/suppliers/${id}`),
  createSupplier: (data: any) => api.post('/suppliers', data),
  updateSupplier: (id: number, data: any) => api.put(`/suppliers/${id}`, data),
  deleteSupplier: (id: number) => api.delete(`/suppliers/${id}`),

  // Purchase Orders
  getPurchaseOrders: (status?: string) => api.get(`/purchaseorders${status ? `?status=${status}` : ''}`),
  getPurchaseOrder: (id: number) => api.get(`/purchaseorders/${id}`),
  createPurchaseOrder: (data: any) => api.post('/purchaseorders', data),
  updatePOStatus: (id: number, status: string) => api.post(`/purchaseorders/${id}/status`, { status }),
  generateInvoiceFromPO: (id: number, dueDate?: string) =>
    api.post(`/purchaseorders/${id}/generate-invoice`, { dueDate: dueDate || null }),

  // Goods Receipts
  getGoodsReceipts: () => api.get('/goodsreceipts'),
  getGoodsReceipt: (id: number) => api.get(`/goodsreceipts/${id}`),
  createGoodsReceipt: (data: any) => api.post('/goodsreceipts', data),
  // Purchase Invoices (Bills)
  getPurchaseInvoices: (status?: string) => api.get(`/purchaseinvoices${status ? `?status=${status}` : ''}`),
  getPurchaseInvoice: (id: number) => api.get(`/purchaseinvoices/${id}`),
  createPurchaseInvoice: (data: any) => api.post('/purchaseinvoices', data),
  updatePurchaseInvoiceStatus: (id: number, status: string) => api.put(`/purchaseinvoices/${id}/status`, { status }),
  recordPurchaseInvoicePayment: (id: number, data: any) => api.post(`/purchaseinvoices/${id}/payments`, data),
};

export default procurementService;
